import classNames from "classnames";
import React, { FC, useMemo } from "react";
import styles from "./AccountItem.module.scss";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/layout/close.svg";

type Props = {
  id: number;
  name: string;
  isActive: boolean;
  onSelect: (id: number, isActive: boolean) => void;
  onRemove: (id: number, isActive: boolean) => void;
};

const AccountItem: FC<Props> = ({ id, name, isActive, onSelect, onRemove }) => {
  return (
    <div className={classNames(styles.accountItem, {[styles.active]: isActive})}>
      <span onClick={() => {onSelect(id, isActive)}}>
        {name}
      </span>
      <CloseIcon onClick={() => {onRemove(id, isActive)}}/>
    </div>
  );
};
export default AccountItem;